export const SELECT_TEXT = {
  /** 값이 없을 때의 안내(Figma `Value` 기본값) */
  placeholder: '선택하세요',
} as const;
